function toggleFilter() {
    let x = document.querySelector(".sq-filter-main");
    x.classList.toggle("opening");
}
function toggleClass() {
    let y = document.querySelector(".sq-filter-main");
    y.classList.remove("opening");
}
function removeClass() {
    let z = document.querySelector(".sq-filter-main");
    z.classList.remove("opening");
}

window.sq = window.sq || {};

// Attach to window and auto-run
window.fixSearchUrl = function (href = window.location.href) {
  const url = new URL(href);

  // Only handle /search pages
  if (url.pathname !== "/search") return href;

  // Remove &type=product
  url.searchParams.delete("type");

  // Get q and clean it
  let q = url.searchParams.get("q") || "";

  // Convert + to spaces for decoding, then decode
  q = decodeURIComponent(q.replace(/\+/g, " "));

  // Strip the "NOT tag:__gift AND " prefix (case-insensitive)
  q = q.replace(/^NOT\s+tag:__gift\s+AND\s*/i, "");

  // Drop trailing '*' wildcard(s)
  q = q.replace(/\*+$/, "").trim();

  // Re-set cleaned q (properly encoded)
  url.searchParams.set("q", q);

  const newUrl = `${url.origin}${url.pathname}?${url.searchParams.toString()}`;

  // Replace without reload if we're on this page
  if (href === window.location.href) {
    window.history.replaceState({}, "", newUrl);
  }
  return newUrl;
};

// Run once now
window.fixSearchUrl();

window.addEventListener("load", () => {
    if (window.matchMedia("(max-width: 767px)").matches) {
        document
            .getElementById("Search-In-Modal")
            .addEventListener("focusin", () => {
                document.querySelector(".sq-dropdown-body").style.maxHeight = "100%";
            });
        document
            .getElementById("Search-In-Modal")
            .addEventListener("focusout", () => {
                document.querySelector(".sq-dropdown-body").style.maxHeight = "0px";
            });
    }
});

window.sq.initSearch = (store) => {
    store.search();
};


setTimeout(()=>{
    if(document.querySelector(".sq-filter-main")) document.querySelector(".sq-filter-main").style.visibility=null;
    if(document.querySelector(".sparq-container")) document.querySelector(".sparq-container").style.visibility=null;
},200);

window.addEventListener("keydown",(e)=>{
    if (e.key === "Escape") {
        document.querySelector("footer").click();
    }
});
window.sq.fetchPrice = function (item, isDropdown = false) {
  var selector;

  // Currency symbol mapping
  const currencySymbols = {
    USD: "$",
    EUR: "€",
    GBP: "£",
    INR: "₹",
    AUD: "A$",
    CAD: "C$",
    JPY: "¥",
    CNY: "¥",
    CHF: "CHF",
    SEK: "kr",
    NZD: "NZ$"
    // Add more as needed
  };

  fetch(location.origin + `/products/${item.handle.toLowerCase()}.json`)
    .then((data) => data.json())
    .then((obj) => {
      if (isDropdown) {
        selector = document.querySelectorAll(
          `.sq-dropdown-body [product-handle="${item.handle}"]`
        );
      } else {
        selector = document.querySelectorAll(
          `[product-handle="${item.handle}"]`
        );
      }

      const currency = Shopify.currency.active;
      const symbol = currencySymbols[currency] || currency;

      const productId = obj.product.variants[0].id;
      const variantsCount = obj.product.variants.length;

      if (obj.product.variants[0].price) {
        selector.forEach((e) => {
          var s=parseFloat(obj.product.variants[0].price);
          var s1=s.toFixed(2);
          e.querySelector(`.price-list--our .price`).innerHTML =
            symbol + " " + s1;
          
        });
      }

      if (obj.product.variants[0].price) {
         var s=parseFloat(obj.product.variants[0].price);
        s=s*1.2;
          var s1=s.toFixed(2);
        selector.forEach((e) => {
          e.querySelector(`.price-list--inc-vat .price`).innerHTML =
            symbol + " " + s1;
        });
      }
    });

  return true;
};